module.exports = __webpack_public_path__ + "img/users-down.c3ae1cfd.svg";